{
  "remove": "Quitar"
}
